import { createAction } from 'redux-actions';
import types from '../types';

export const showDetailView = createAction(types.SHOW_DETAIL_VIEW);
export const deleteIncident = createAction(types.DELETE_REQUESTED);
